export const formatTime = time => {
  let date = new Date(time);
  let options = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  };
  return date.toLocaleDateString("en", options);
};
